module.exports = __webpack_public_path__ + "static/img/pc-web-img-01@t.a92500f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/d-steady/pc-web-img-01@t.png
// module id = A25D
// module chunks = 0